module.exports = __webpack_public_path__ + "static/photo-cooptation-34f765fe8d364604e215b43b14981785.jpg";